import { cn } from "@utils";
import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { FormLabel } from "@components";

export const ReasonGrid = ({ field, options, heading = "Reason for dispute", error, submitted, touched }) => {
  const showError = error && (touched || submitted);
  return (
    <div>
      <FormLabel>{heading}</FormLabel>
      <div role="radiogroup" aria-label={heading} className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {options.map(({ value, label }) => {
          const selected = field.value === value;
          return (
            <button
              key={value}
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => field.onChange(value)}
              className={cn(
                "flex items-center justify-center rounded-xl border px-3 py-2.5 text-sm font-medium text-center transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1",
                selected
                  ? "border-primary-500 bg-primary-50 text-primary-700 shadow-sm"
                  : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300 hover:bg-zinc-50"
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
      {showError && (
        <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
          <ExclamationCircleIcon className="size-4 shrink-0" />
          {error.message}
        </p>
      )}
    </div>
  );
};
